import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionDelegateRemovePayload } from 'api/actions/revision-delegate-remove/revision-delegate-remove-payload';
import { RevisionDelegateRemovePathParameters } from 'api/actions/revision-delegate-remove/revision-delegate-remove-path-parameters';
import { RevisionDelegateRemoveResponse } from 'api/actions/revision-delegate-remove/revision-delegate-remove-response';

type RevisionDelegateRemoveQueryParameters = Record<string, any>;

/**
 * The path of the RevisionDelegateRemove action.
 */
export const revisionDelegateRemoveActionPath = new SweetPath<keyof RevisionDelegateRemovePathParameters>(
  '/api/revision/delegate-remove/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionDelegateRemove actions.
 */
export default function createRevisionDelegateRemoveAction(axios: AxiosInstance) {
  return function revisionDelegateRemoveAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionDelegateRemovePathParameters;
    query?: RevisionDelegateRemoveQueryParameters;
    payload: RevisionDelegateRemovePayload;
  }) {
    const path = revisionDelegateRemoveActionPath.insert(parameters);

    return axios.request<RevisionDelegateRemoveResponse, RevisionDelegateRemoveResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
